// components/ChoosePassword.tsx
import { Button } from 'components/button';
import { Input } from 'components/fields/input';
import React from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';

interface ChoosePasswordFormData {
    password: string;
}

const EnterPassword: React.FC = () => {
    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<ChoosePasswordFormData>({
        mode: 'onBlur', // Validate on blur
    });

    const onSubmit: SubmitHandler<ChoosePasswordFormData> = (data) => {
        // Add your submission logic here (e.g., API call)
    };

    return (
        <form
            className="flex flex-col gap-3"
            onSubmit={handleSubmit(onSubmit)}
            noValidate
        >
            {/* Password Field */}
            <Controller
                name="password"
                control={control}
                rules={{
                    required: 'Password is required.',
                }}
                render={({ field }) => (
                    <Input
                        fullWidth
                        label="Password"
                        type="password"
                        placeholder="Enter your password"
                        {...field}
                        error={errors.password?.message}
                    />
                )}
            />

            {/* Submit Button */}
            <Button className="w-full mt-4" type="submit">
                Sign In
            </Button>
        </form>
    );
};

export default EnterPassword;
